import { useLocale } from "../../../hooks/useLocale";
import { msg } from "../../../locales/translate";
import { HBox, VBox } from "@ui/box/Box";
import Button from "@ui/button/Button";
import Panel from "@ui/panel/Panel";
import Spacer from "@ui/spacer/Spacer";
import { Typo } from "@ui/text/Typo";
import Signal from "badmfck-signal";
import React from "react";

export const S_CONFIRM = new Signal<{
	title?: string;
	message: string | JSX.Element;
	confirm?: string;
	reject?: string;
	onResult: (val: "confirm" | "reject") => void;
} | null>("S_CONFIRM");

export const ConfirmDialog = () => {
	useLocale();
	const requestData = S_CONFIRM.use();

	if (!requestData) return null;

	const handleSubmit = async () => {
		if (requestData && requestData.onResult) {
			requestData.onResult("confirm");
		}
		closePopup();
	};

	const closePopup = () => {
		S_CONFIRM.invoke(null);
	};

	const rejectPopup = () => {
		if (requestData && requestData.onResult) {
			requestData.onResult("reject");
		}
		closePopup();
	};

	return (
		<Panel
			growContent
			sx={{
				maxWidth: "1200px",
				padding: "0",
				maxHeight: "90vh",
				minWidth: "500px",
			}}
			decorator="absolute"
			label={requestData.title ?? msg("confirm")}
			onClose={closePopup}>
			<VBox
				gap="20px"
				sx={{
					overflow: "auto",
					flexGrow: 1,
					// height:'auto',
					padding: "30px 0px",
				}}>
				{React.isValidElement(requestData.message) ? requestData.message : <Typo variant="text">{requestData.message}</Typo>}
			</VBox>

			<Spacer size="20px" />

			<HBox sx={{ gap: "12px", width: "100%" }}>
				{requestData.reject && (
					<Button
						variant="secondary"
						sx={{ flex: 1 }}
						title={requestData.reject}
						onClick={() => {
							rejectPopup();
						}}
					/>
				)}
				<Button
					sx={{ flex: 1 }}
					title={requestData.confirm ?? msg("ok")}
					onClick={() => {
						handleSubmit();
					}}
				/>
			</HBox>
		</Panel>
	);
};
